import UIElement from './UIElement';
import NavSubMenu from './NavSubMenu';
import DesktopManager from './DesktopManager';

export default class NavMenu extends UIElement {
  public static readonly Selector: string = '#nav-menu';

  public readonly subMenus: NavSubMenu[];

  public constructor(element: HTMLElement, desktopManager: DesktopManager) {
    super(element);
    this.subMenus = this.$element
      .find(NavSubMenu.Selector)
      .map((_, elem) => {
        return new NavSubMenu(this, elem, desktopManager);
      })
      .get();
  }

  public override mount(): void {
    this.subMenus.forEach((subMenu) => {
      subMenu.mount();
    });
  }

  public closeOtherAttachedSubmenus(source: NavSubMenu) {
    this.subMenus
      .filter((val) => val.attached && val !== source)
      .forEach((subMenu) => {
        subMenu.close();
      });
  }
}
